import {
  FETCH_JOBS_REQUEST,
  FETCH_JOBS_SUCCESS,
  FETCH_JOBS_FAILURE,
  ADD_JOB_REQUEST,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAILURE,
  UPDATE_JOB_REQUEST,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  DELETE_JOB_REQUEST,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAILURE,
} from './actionType';

const initialState = {
  jobs: [],
  status: 'idle',
  error: null,
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOBS_REQUEST:
    case ADD_JOB_REQUEST:
    case UPDATE_JOB_REQUEST:
    case DELETE_JOB_REQUEST:
      return { ...state, status: 'loading', error: null };
    case FETCH_JOBS_SUCCESS:
      return { ...state, status: 'succeeded', jobs: action.payload, error: null };
    case FETCH_JOBS_FAILURE:
    case ADD_JOB_FAILURE:
    case UPDATE_JOB_FAILURE:
    case DELETE_JOB_FAILURE:
      return { ...state, status: 'failed', error: action.payload };
    case ADD_JOB_SUCCESS:
      return { ...state, status: 'succeeded', jobs: [...state.jobs, action.payload], error: null };
    case UPDATE_JOB_SUCCESS:
      return {
        ...state,
        status: 'succeeded',
        jobs: state.jobs.map((job) =>
            job.id === action.payload.id ? { ...job, ...action.payload } : job
        ),
        error: null,
      };
    case DELETE_JOB_SUCCESS:
      return {
        ...state,
        status: 'succeeded',
        jobs: state.jobs.filter((job) => job.id !== action.payload.id),
        error: null,
      };
    default:
      return state;
  }
};

export default jobReducer;